import { useState, useEffect } from 'react';
import api from '@/lib/api';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Heart, ShoppingCart, Trash2 } from 'lucide-react';

export default function CustomerWishlist() {
  const [items, setItems] = useState([]);

  const fetchWishlist = async () => {
    const res = await api.get('/customer/wishlist');
    setItems(res.data.items || []);
  };
  useEffect(() => { fetchWishlist(); }, []);

  const removeItem = async (productId) => {
    await api.delete(`/customer/wishlist/${productId}`);
    setItems(items.filter(i => i.product_id !== productId));
  };

  const fmt = (v) => new Intl.NumberFormat('id-ID').format(v || 0);

  return (
    <div>
      <div className="flex items-center gap-2 mb-6">
        <Heart size={20} className="text-red-500" />
        <h1 className="text-2xl font-bold tracking-tight text-slate-900" style={{ fontFamily: 'Plus Jakarta Sans' }}>Wishlist</h1>
        <Badge variant="outline" className="ml-2">{items.length} item</Badge>
      </div>

      {items.length === 0 ? (
        <Card className="border-dashed border-slate-300">
          <CardContent className="py-16 text-center">
            <Heart size={40} className="mx-auto mb-3 text-slate-300" />
            <p className="text-slate-400">Wishlist kamu masih kosong</p>
            <p className="text-sm text-slate-400">Tap ikon hati pada produk untuk menyimpannya</p>
          </CardContent>
        </Card>
      ) : (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {items.map(item => (
            <Card key={item.product_id} className="border-slate-200 overflow-hidden">
              {item.product?.images?.[0] && (
                <div className="aspect-video bg-slate-100">
                  <img src={item.product.images[0]} alt={item.product?.name} className="w-full h-full object-cover" />
                </div>
              )}
              <CardContent className="p-4">
                <div className="flex items-start justify-between gap-2">
                  <div className="min-w-0">
                    <p className="font-medium text-slate-900 truncate">{item.product?.name || 'Produk dihapus'}</p>
                    <p className="text-lg font-bold text-[var(--store-primary, #2D6CDF)] mt-1">Rp {fmt(item.product?.sale_price || item.product?.price)}</p>
                    {item.product?.type && (
                      <Badge variant="outline" className="text-xs mt-1">{item.product.type}</Badge>
                    )}
                  </div>
                  <Button variant="ghost" size="icon" className="text-red-400 hover:text-red-600 shrink-0" onClick={() => removeItem(item.product_id)}>
                    <Trash2 size={16} />
                  </Button>
                </div>
                <p className="text-xs text-slate-400 mt-2">Ditambahkan {new Date(item.created_at).toLocaleDateString('id-ID')}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
